<template>
  <div id="app">
    <AlertBar />
    <ModalPrompt v-if="modal.show" :modal="modal" />
    <!-- <CookieBar /> -->
    <router-view />
  </div>
</template>

<script>
import './validationRules'
import { actions, getters } from './views/utils'
import { defaultLocale, hasSockets } from './config'
import AlertBar from './views/components/AlertBar'

export default {
  name: 'App',
  components: { AlertBar },
  computed: getters('hasAuthChecked', 'implyInitialLocale', 'isPathDynamic', 'modal'),
  methods: actions(
    'AUTO_SET_LOCALE',
    'CHECK_SCREEN_SIZE',
    'INIT_LOCAL_STORAGE',
    'SYNC_GLOBAL',
  ),
  watch: {
    hasAuthChecked() {
      if (!this.isAuth) {
        this.LOAD('FETCH_STATE')
      }
    },
    isAuth(isAuth) {
      this.LOAD('FETCH_STATE')
    },
  },
  async beforeMount() {
    this.INIT_LOCAL_STORAGE(this)
    this.LOAD('CHECK_LOGIN')

    if (hasSockets) this.SYNC_GLOBAL()

    this.CHECK_SCREEN_SIZE()
    this.$offEvents = await this.ON({
      resize: this.CHECK_SCREEN_SIZE,
    })
    const homepage = 'Index'
    const routeLocale = this.implyInitialLocale()
    const locale = await this.AUTO_SET_LOCALE({
      isHomepage: this.$route.name === homepage,
      routeLocale,
    })

    if (locale !== routeLocale && !(locale === defaultLocale && !routeLocale)) {
      this.$nextTick(() => {
        // NOTE: hackish way, gives time for $router to initialize
        const routeName = this.isPathDynamic(this)
          ? homepage
          : this.$route.name || homepage
        this.$router.replace({ name: routeName, params: { locale } })
      })
    }

    // timeout for pre-render to take a snapshot only after state has been loaded
    setTimeout(() => {
      document.dispatchEvent(new Event('x-app-rendered'))
    }, 2000)
  },
  beforeDestroy() {
    this.$offEvents && this.$offEvents()
  },
}
</script>

<style lang="scss">
#app {
  font-family: $font-body;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
  overflow: hidden;
  width: 100%;
}
</style>
